
export const display = {
  namespaced: true,
  state: {
    isAside: false,
    local:'en'
  },  
  getters: {
    getAside(state) {
      return state.isAside;
    },
    getLocal(state) {
      return state.local;
    }
  },
  mutations: {
    SET_Aside(state) {
      state.isAside =!state.isAside
    },
    SET_Local(state,local) {
      state.local = local
    },
  },
  actions: {
    toggle_Aside({ commit }) {
      commit("SET_Aside");
    },
    setLocal({ commit },local) {
      commit("SET_Local",local);
    },
  },
  modules: {
  }
};
